<div id="triangle-up-blue"></div>
<div id="triangle-up-white"></div>
<!-- contact popup -->
<app-contact-menu *ngIf="menuType==='contact'"> </app-contact-menu>

<!-- lang popup -->
<app-locale-menu *ngIf="menuType==='locale'"> </app-locale-menu>
